import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: ${props => props.$isListening
    ? 'var(--primary-color)'
    : 'var(--primary-color-transparent)'};
  cursor: pointer;
  transition: all 0.2s ease;
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;

  &:hover {
    color: var(--primary-color);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const MicIcon = styled.svg`
  width: 20px;
  height: 20px;
  fill: currentColor;
`;

const PulsingCircle = styled.div`
  position: absolute;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--primary-color-transparent);
  opacity: 0.2;
  animation: pulse 1.5s infinite;

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.2;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.1;
    }
    100% {
      transform: scale(1);
      opacity: 0.2;
    }
  }
`;

const MicrophoneButton = ({ isListening, onClick, disabled }) => {
  return (
    <Button
      onClick={onClick}
      $isListening={isListening}
      disabled={disabled}
      aria-label={isListening ? "Stop listening" : "Start listening"}
    >
      {isListening && <PulsingCircle />}
      <MicIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/>
        <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
      </MicIcon>
    </Button>
  );
};

export default MicrophoneButton;
